goog.provide('el8.appchart.unverifiedPatient');

goog.require('el8.appservice.banner');
goog.require('el8.service.urls');
goog.require('el8.appchart.dialog.mergeChart');
goog.require('el8.ptdata.careTeamProviders');

el8.appchart.unverifiedPatient = (function () {

  return {
    init: function () {
      if (!el8.ptdata.currPatient.isVerified()) {
        if (el8Globals.FEATURES.PLR4Everyone &&
          el8.ptdata.careTeamProviders.all().length > 1 &&
          el8.ptdata.careTeamProviders.isUserInList(el8.data.currUser.getId())) {
          showReferralMergeBanner()
        } else {
          showMergeChartBanner()
        }

      }
    }
  };
})();


function showReferralMergeBanner() {
  el8.appservice.banner.show({
    color: 'teal',
    contentFn: function () {
      return 'Congratulations! You’ve created a new chart from a referral. If you already have a chart for this patient, you can merge them now.';
    },
    buttons: [
      {
        name: 'merge-chart',
        caption: 'Merge Chart',
        fn: function () {
          el8.appchart.dialog.mergeChart.show();
        }
      },
      {
        name: 'keep',
        caption: 'Dismiss',
        fn: function () {
          $.el8_ajax({
            type: 'POST',
            async: false,
            url: el8.service.urls.get('markChartVerified')
          });
        }
      }
    ]
  });

}


function showMergeChartBanner() {
  el8.appservice.banner.show({
    contentFn: function () {
      return 'This chart was created automatically and may be a duplicate.';
    },
    buttons: [
      {
        name: 'merge-chart',
        caption: 'Merge Chart',
        fn: function () {
          el8.appchart.dialog.mergeChart.show();
        }
      },
      {
        name: 'keep',
        caption: 'Dismiss',
        fn: function () {
          $.el8_ajax({
            type: 'POST',
            async: false,
            url: el8.service.urls.get('markChartVerified')
          });
        }
      }
    ]
  })
}

